/**
 * Single source of truth for the docked sidebar's widths. `SidebarContainer`
 * sets these as inline CSS custom properties on the panel root and on
 * `#main`, so `sidebar.scss` and `main.scss` never hardcode `960`/`280`
 * themselves and can't drift out of sync.
 */
export const SIDEBAR_WIDTH_PX = 480;
export const SIDEBAR_EXPANDED_WIDTH_PX = 960;
export const SIDEBAR_RAIL_WIDTH_PX = 280;
